import { VenueCreateInviteInputV2 } from '../../graphql/API';
import { venueCreateInviteV2 } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueCreateInviteV2Api = async (input: VenueCreateInviteInputV2): Promise<void> => {
  await executeGql<void>(venueCreateInviteV2, { input });
};
